import styled from 'styled-components';

export const ProgressContainer = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(0%, 5%);
`;
